import React from 'react';

const GlfhFaq = () => {
  return (
    <div className="container">
      <h2 className="section__title-small text--black text--bold">
        Frequently Asked Questions
      </h2>
      <div className="faq">
        <div
          className="faq__header collapsed"
          data-toggle="collapse"
          data-target="#question_1"
        >
          <p>What is a Gold Loan from Home? </p>
          <span></span>
        </div>
        <div className="faq__answer collapse" id="question_1">
          <p>
            A Gold Loan from Home is a service where you can get a Gold Loan at
            your home, unlike the traditional Gold Loan where you visit a Bank
            or an NBFC. We process your Gold Loan at your home seamlessly. Our
            loan managers will carry your gold jewellery safely to a nearby
            Muthoot FinCorp branch, so you don&apos;t have to worry about
            traveling with your gold jewellery.
            <br /> **Available in selected cities
          </p>
        </div>
      </div>
      <div className="faq">
        <div
          className="faq__header collapsed"
          data-toggle="collapse"
          data-target="#question_2"
        >
          <p>What are the benefits of getting a Gold Loan from Home? </p>
          <span></span>
        </div>
        <div className="faq__answer collapse" id="question_2">
          <p>
            When you book an appointment for a Gold Loan from Home, we come to
            your home to collect the gold jewellery at your preferred date and
            time, making the process easy, hassle-free, and seamless.
            Additionally, we carry your pledged gold jewellery to a nearby
            Muthoot FinCorp branch in a GPS-tracked safe locker, so you
            don&apos;t have to carry it yourself. Your pledged gold jewellery is
            automatically insured as an added layer of protection.
          </p>
        </div>
      </div>
      <div className="faq">
        <div
          className="faq__header collapsed"
          data-toggle="collapse"
          data-target="#question_3"
        >
          <p>
            How is a Gold Loan from Home different from a traditional Gold Loan?
          </p>
          <span></span>
        </div>
        <div className="faq__answer collapse" id="question_3">
          <p>
            A Gold Loan from Home is a service where you can get a Gold Loan at
            your home, unlike the traditional Gold Loan where you visit a Bank
            or an NBFC. We process your Gold Loan at your home seamlessly and
            our loan managers carry your gold jewellery safely to a nearby
            Muthoot FinCorp branch, so you don&apos;t have to worry about
            traveling with your gold jewellery.
          </p>
        </div>
      </div>
      <div className="faq">
        <div
          className="faq__header collapsed"
          data-toggle="collapse"
          data-target="#question_4"
        >
          <p>
            What are the different Gold Loan schemes available for Gold Loan
            from Home?{' '}
          </p>
          <span></span>
        </div>
        <div className="faq__answer collapse" id="question_4">
          <p>
            We offer various schemes on our Gold Loan from Home that you can get
            through our app. To check the details of the different schemes
            available please visit the Gold Loan page on the app.
          </p>
        </div>
      </div>
      <div className="faq">
        <div
          className="faq__header collapsed"
          data-toggle="collapse"
          data-target="#question_5"
        >
          <p>What is the tenure for repayment of a Gold Loan from Home? </p>
          <span></span>
        </div>
        <div className="faq__answer collapse" id="question_5">
          <p>
            You can choose the tenure of your liking depending on your loan
            amount and the various Gold Loan schemes available when you get our
            Gold Loan from Home. Please go through the different schemes in
            detail before selecting the tenure and scheme.
          </p>
        </div>
      </div>
      {/* <div className="faq">
        <div
          className="faq__header collapsed"
          data-toggle="collapse"
          data-target="#question_6"
        >
          <p>What is a holiday period in a Gold Loan from Home?</p>
          <span></span>
        </div>
        <div className="faq__answer collapse" id="question_6">
          <p>
            A holiday period is a period in a loan during which the interest
            slab remains the same. You can ask about the holiday period in your
            selected scheme from our Loan Manager, once you make an appointment
            with us for a Gold Loan from Home.
          </p>
        </div>
      </div> */}
      <div className="faq">
        <div
          className="faq__header collapsed"
          data-toggle="collapse"
          data-target="#question_7"
        >
          <p>
            Can I make changes to the existing Gold Loan from Home schemes
            available?{' '}
          </p>
          <span></span>
        </div>
        <div className="faq__answer collapse" id="question_7">
          <p>
            All our schemes have been designed keeping the best interest of our
            customers in mind and you can pick the scheme of your liking basis
            the loan amount, rate of interest, and other parameters that work
            best for you. To check the details of the schemes available please
            visit the Gold Loan page on the app.
          </p>
        </div>
      </div>
      <div className="faq">
        <div
          className="faq__header collapsed"
          data-toggle="collapse"
          data-target="#question_8"
        >
          <p>In which cities is Gold Loan from Home available?</p>
          <span></span>
        </div>
        <div className="faq__answer collapse" id="question_8">
          <p>
            Currently we offer a Gold Loan from Home in Agra, Amritsar,
            Ahmedabad, Bangalore, Baroda, Bhopal, Bhubaneswar, Chandigarh,
            Chennai, Cochin, Coimbatore, Cuttack, Delhi-NCR, Hyderabad, Indore,
            Jaipur, Kanpur, Kolkata, Kota, Lucknow, Ludhiana, Madurai, Mumbai,
            Nagpur, Pune, Surat, Trivandrum, Vijayawada and Visakhapatnam. Gold
            Loan from Home is coming soon to more cities in India.
          </p>
        </div>
      </div>

      <div className="faq">
        <div
          className="faq__header collapsed"
          data-toggle="collapse"
          data-target="#question_9"
        >
          <p>
            What is Loan-to-Value (LTV) rate for Gold Loans and how does it
            impact my loan amount?
          </p>
          <span></span>
        </div>
        <div className="faq__answer collapse" id="question_9">
          <p>
            The LTV (Loan-to-Value) rate determines your maximum Gold Loan
            amount eligibility for the appraised value of your gold jewellery.
            Since gold prices fluctuate daily, it directly impacts your maximum
            loan eligibility. Additionally, the scheme you select also
            determines the final Gold Loan amount. For more details please check
            the Muthoot FinCorp ONE app to understand your borrowing capacity.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GlfhFaq;
